// ----------------------------------------------------------------------------
// Component: Promo Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_promo-banner.scss';
